import request from "@/utils/request";
import { RequestDataHelper } from "../helper";
import { IRMenuParam } from "./types";


/**
 * 登录接口
 * @param userData 
 * @returns 
 */
export function ApiLogin(userData: any) {
  let form = new FormData()
  form.append('username', userData.username)
  form.append('password', userData.password)
  form.append('grant_type', userData.grant_type)
  form.append('client_id', userData.client_id)
  form.append('client_secret', userData.client_secret)
  return request({
    method: 'POST',
    url: '/login',
    headers: {
      // "Content-Type": 'application/x-www-form-urlencoded'
      "Content-Type": 'multipart/form-data'
    },
    data: form
  })
}


/**
 * 注册接口
 * @param userData 
 * @returns 
 */
export function ApiRegister(userData: any) {
  // let form = new FormData()
  // form.append('phone', userData.phone)
  // form.append('password', userData.password)
  return request({
    method: 'POST',
    url: '/web/user/register',
    // headers: {
    //   // "Content-Type": 'application/x-www-form-urlencoded'
    //   "Content-Type": 'multipart/form-data'
    // },
    data: userData
  })
}
/**
 * 注册短信验证码
 * @param userData 
 * @returns 
 */
export function ApiSmsCode(params: Record<string, any>) {
  return request({
    method: 'GET',
    url: `/web/user/sms_code`,
    params
  })
}
/**
 * 根据手机号码获取忘记密码验证密码
 * @param userData 
 * @returns 
 */
export function ApiForgotCode(params: Record<string, any>) {
  return request({
    method: 'GET',
    url: `/web/user/forgot/password/code`,
    params
  })
}
/**
 * 根据短信验证码重置用户密码
 * @param userData 
 * @returns 
 */
export function ApiReset(params: Record<string, any>) {
  return request({
    method: 'PUT',
    url: `/web/user/forgot/password`,
    data: params
  })
}
/**
 * 获取当前用户信息
 * @returns 
 */
export function ApiGetUserinfo() {
  return request({
    method: 'GET',
    url: '/user',
  })
}

/**
 * 获取菜单
 * @param params 
 * @returns 
 */
export function APIGetMenu(params: IRMenuParam) {
  params = { ...params, page: '1', limit: '999' }
  return request({
    method: 'GET',
    url: '/wxPurchase/ProcessionList',
    params
  })
}

